export enum CustomersQueryKeys {
  GET_CUSTOMERS_LIST = 'GET_CUSTOMERS_LIST',
}
